import { StaticBaseDao } from '@/dao';
import { JsonSettings } from '@/objects/generated';
import type { JsonSettingsType } from './../enums/JsonSettingsType';

export class JsonSettingsDao extends StaticBaseDao {
    public static async GetSettings(
        type: JsonSettingsType,
        EventId: number | null,
        UserId: number | null,
        OrganizerId: number | null,
    ): Promise<JsonSettings | null> {
        return this.BaseFetch(
            JsonSettings,
            `JsonSettings/GetSettings` +
                '?' +
                (type == undefined ? '' : `type=${type}`) +
                '&' +
                (EventId == undefined ? '' : `EventId=${EventId}`) +
                '&' +
                (UserId == undefined ? '' : `UserId=${UserId}`) +
                '&' +
                (OrganizerId == undefined ? '' : `OrganizerId=${OrganizerId}`),
            'GET',
        );
    }
    public static async SaveSettings(settings: JsonSettings): Promise<number | null> {
        return this.Post(`JsonSettings/SaveSettings`, settings);
    }
}
